import React from 'react';
import {useTranslate} from "../useTranslate";
import Flag from "react-flagpack";

function LanguageItem({option, props}) {
    const translate = useTranslate();
    return(
        <div className={`flex flex-column  ${option.code!=="fa"?"english-font":"shabnam-font"}`}><div className="flex gap-1 align-items-center"><Flag size="s" code={option.flag}/><div className="flex align-items-baseline gap-1"><span className="text-xs text-gray-400">{/*option.code*/}</span><span>{translate(option.name)}</span></div></div></div>
    )
}

export default LanguageItem;